export default function triggerEdapEvent(eventData, eventName = 'generic.event') {
    window.edap.push((edapInstance) => {
        edapInstance.trigger(eventName, {
            eventcategory: 'regional settings',
            ...eventData
        });
    });
}
